import avatar from '../../assets/images/avatar.svg'
import {
  AvatarStyles,
  CardTourStyles,
  CardTourWithAvatarStyles,
} from './styles'

const TourImportarPlanilha = [
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <span>Dúvidas sobre como realizar a importação da planilha?</span>
        <br />
        <br />
        <strong> Vamos lá!</strong>
      </CardTourWithAvatarStyles>
    ),
    target: '#saudacaoPlanilha',
    placement: 'center',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Preenchendo a planilha</p>
        <span>
          Clique no ícone de download da planilha exemplo e faça o preenchimento
          dos dados.
        </span>
      </CardTourStyles>
    ),
    target: '#download',
    placement: 'right-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Importação</p>
        <span>
          Clique no ícone <strong>anexar planilha </strong> para abrir o
          gerenciador de arquivos e selecione o arquivo que você preencheu no
          passo anterior.
        </span>
      </CardTourStyles>
    ),
    target: '#anexar',
    placement: 'right-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Processamento de dados</p>
        <span>
          Clique em processar os dados e aguarde! <br />
          Assim que concluído o sistema irá te encaminhar para a tela de vendas,
          onde poderá conferir os dados importados.
        </span>
      </CardTourStyles>
    ),
    target: '#processarDados',
    placement: 'right-fixed',
  },

  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <strong>Pronto!</strong>
        <br />
        <br />
        <span>Um passo a frente no follow up dos seus clientes!</span>
      </CardTourWithAvatarStyles>
    ),
    target: '#finalizacaoPlanilha',
    placement: 'center',
  },
]
export default TourImportarPlanilha
